module.exports = __webpack_public_path__ + "static/img/17.a3d8b80.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/XVC/images/17.png
// module id = Au/7
// module chunks = 4